import PropTypes from 'prop-types';

import {copyableProperty, getContentTierName, getProperty} from '../common';

export const tournament = (event) => {
    const eventData = {
        data: event,
        srWithMatchID: ['match', 'tournament'],
        srWithoutMatchID: ['tournament'],
    };

    return copyableProperty(
        eventData,
        'Tournament',
        getProperty(eventData, 'name') + getContentTierName(event)
    );
};

tournament.propTypes = {
    event: PropTypes.object.isRequired,
};
